import { RouterStore } from '@superwf/mobx-react-router';
import isNode from 'is-node';
import { MobXProviderContext } from 'mobx-react';
import React from 'react';
import AddressAutocompleteStore from './AddressAutocompleteStore';

import AddressStore from './AddressStore';
import BannersStore from './BannersStore';
import BillingStore from './BillingStore';
import BlacklistStore from './BlacklistStore';
import BranchStore from './BranchStore';
import BreadcrumbStore from './BreadcrumbStore';
import CallbackStore from './CallbackStore';
import ContactInfoStore from './ContactInfoStore';
import ContentStore from './ContentStore';
import CookieConsentStore from './CookieConsentStore';
import CountryCallingCodeStore from './CountryCallingCodeStore';
import CouponStore from './CouponStore';
import DigitarkNewsStore from './DigitarkNewsStore';
import DiscountCodeStore from './DiscountCodeStore';
import DiscountStore from './DiscountStore';
import FooterStore from './FooterStore';
import GaDataStore from './GaDataStore';
import Go3Store from './Go3Store';
import GuideStore from './GuideStore';
import InsuranceStore from './InsuranceStore';
import InternetCalculatorStore from './InternetCalculatorStore';
import JobAndInternshipOffersStore from './JobOffersStore';
import LanguageStore from './LanguageStore';
import MenuStore from './MenuStore';
import MobileBusinessStore from './MobileBusinessStore';
import MobileLifeStore from './MobileLifeStore';
import MovieDetailsStore from './movierental/MovieDetailsStore';
import MovieRentalCatalogStore from './movierental/MovieRentalCatalogStore';
import Ms365Store from './Ms365Store';
import NewsStore from './NewsStore';
import PriceListStore from './PriceListStore';
import SegmentStore from './SegmentStore';
import PersonalOffersStore from './PersonalOffersStore';
import ProductDetailsStore from './ProductDetailsStore';
import ProductPriceStore from './ProductPriceStore';
import ProductStore from './ProductStore';
import ProposalStore from './ProposalStore';
import ReservationStore from './ReservationStore';
import RoamingNumberStore from './RoamingNumberStore';
import RoamingStore from './RoamingStore';
import RouteStore from './RouteStore';
import SearchStore from './SearchStore';
import SecureNetStore from './SecureNetStore';
import SelfServiceStore from './SelfServiceStore';
import ShoppingCartStore from './ShoppingCartStore';
import SsoStore from './SsoStore';
import Telia1Store from './Telia1Store';
import TvChannelsStore from './TvChannelsStore';
import FeatureFlagStore from './FeatureFlagStore';
import CampaignStore from './CampaignStore';
import ConstructorPortalStore from './ConstructorPortalStore';
import OnlineHelpEventStore from './OnlineHelpEventStore';

const IS_NODE = isNode;

export class RootStore {
  public initialState: InitialState;
  public isNode: boolean;

  public routing: RouterStore;
  public routeStore: RouteStore;
  public languageStore: LanguageStore;
  public menuStore: MenuStore;
  public contentStore: ContentStore;
  public breadcrumbStore: BreadcrumbStore;
  public newsStore: NewsStore;
  public onlineHelpEventStore: OnlineHelpEventStore;
  public ssoStore: SsoStore;
  public proposalStore: ProposalStore;
  public personalOffersStore: PersonalOffersStore;
  public digitarkNewsStore: DigitarkNewsStore;
  public bannersStore: BannersStore;
  public billingStore: BillingStore;
  public roamingStore: RoamingStore;
  public footerStore: FooterStore;
  public productStore: ProductStore;
  public tvChannelsStore: TvChannelsStore;
  public movieRentalCatalogStore: MovieRentalCatalogStore;
  public movieDetailsStore: MovieDetailsStore;
  public gaDataStore: GaDataStore;
  public jobOffersStore: JobAndInternshipOffersStore;
  public selfServiceStore: SelfServiceStore;
  public addressStore: AddressStore;
  public internetCalculatorStore: InternetCalculatorStore;
  public productPriceStore: ProductPriceStore;
  public priceListStore: PriceListStore;
  public reservationStore: ReservationStore;
  public searchStore: SearchStore;
  public discountStore: DiscountStore;
  public roamingNumberStore: RoamingNumberStore;
  public insuranceStore: InsuranceStore;
  public blacklistStore: BlacklistStore;
  public addressAutocompleteStore: AddressAutocompleteStore;
  public guideStore: GuideStore;
  public shoppingCartStore: ShoppingCartStore;
  public cookieConsentStore: CookieConsentStore;
  public mobileBusinessStore: MobileBusinessStore;
  public productDetailsStore: ProductDetailsStore;
  public secureNetStore: SecureNetStore;
  public discountCodeStore: DiscountCodeStore;
  public ms365Store: Ms365Store;
  public telia1Store: Telia1Store;
  public couponStore: CouponStore;
  public featureFlagStore: FeatureFlagStore;
  public mobileLifeStore: MobileLifeStore;
  public campaignStore: CampaignStore;
  public segmentStore: SegmentStore;
  public go3Store: Go3Store;
  public constructorPortalStore: ConstructorPortalStore;
  public contactInfoStore: ContactInfoStore;
  public callbackStore: CallbackStore;
  public countryCallingCodeStore: CountryCallingCodeStore;
  public branchStore: BranchStore;

  constructor(routing: RouterStore, initialState: InitialState) {
    this.isNode = IS_NODE;
    this.initialState = initialState;
    this.routing = routing;
    this.routeStore = new RouteStore(this);
    this.segmentStore = new SegmentStore(this);
    this.featureFlagStore = new FeatureFlagStore();
    this.languageStore = new LanguageStore(this);
    this.ssoStore = new SsoStore(this);
    this.cookieConsentStore = new CookieConsentStore(initialState.cookieConsents);
    this.menuStore = new MenuStore(this);
    this.contentStore = new ContentStore(this);
    this.breadcrumbStore = new BreadcrumbStore(this);
    this.newsStore = new NewsStore(this);
    this.proposalStore = new ProposalStore(this);
    this.personalOffersStore = new PersonalOffersStore(this);
    this.digitarkNewsStore = new DigitarkNewsStore(this);
    this.bannersStore = new BannersStore(this);
    this.billingStore = new BillingStore(this);
    this.roamingStore = new RoamingStore(this);
    this.footerStore = new FooterStore(this);
    this.productStore = new ProductStore(this);
    this.tvChannelsStore = new TvChannelsStore(this);
    this.gaDataStore = new GaDataStore(this);
    this.movieRentalCatalogStore = new MovieRentalCatalogStore(this);
    this.movieDetailsStore = new MovieDetailsStore(this);
    this.selfServiceStore = new SelfServiceStore(this);
    this.jobOffersStore = new JobAndInternshipOffersStore();
    this.addressStore = new AddressStore();
    this.internetCalculatorStore = new InternetCalculatorStore(this);
    this.productPriceStore = new ProductPriceStore(this);
    this.contactInfoStore = new ContactInfoStore();
    this.countryCallingCodeStore = new CountryCallingCodeStore(this);
    this.reservationStore = new ReservationStore(this);
    this.searchStore = new SearchStore(this);
    this.discountStore = new DiscountStore(this);
    this.roamingNumberStore = new RoamingNumberStore(this);
    this.insuranceStore = new InsuranceStore();
    this.blacklistStore = new BlacklistStore();
    this.addressAutocompleteStore = new AddressAutocompleteStore(this);
    this.guideStore = new GuideStore(this);
    this.shoppingCartStore = new ShoppingCartStore(this);
    this.mobileBusinessStore = new MobileBusinessStore();
    this.productDetailsStore = new ProductDetailsStore(this);
    this.secureNetStore = new SecureNetStore();
    this.discountCodeStore = new DiscountCodeStore();
    this.ms365Store = new Ms365Store();
    this.telia1Store = new Telia1Store(this);
    this.couponStore = new CouponStore(this);
    this.mobileLifeStore = new MobileLifeStore();
    this.campaignStore = new CampaignStore();
    this.priceListStore = new PriceListStore(this);
    this.go3Store = new Go3Store();
    this.constructorPortalStore = new ConstructorPortalStore();
    this.callbackStore = new CallbackStore(this);
    this.branchStore = new BranchStore(this);
    this.onlineHelpEventStore = new OnlineHelpEventStore(this);
  }
}

export default RootStore;

export function useStores(): RootStore {
  return React.useContext(MobXProviderContext) as RootStore;
}
